import { Dictionary, TokenizedData } from '../../models';

export function getTokenize(value: string): TokenizedData {
    const result: TokenizedData = { results: {}, hasDuplicateKeys: false };
    let sb = '';
    let key = '';
    value.split(' ')
        .forEach(s => {
            if (s.indexOf(':') >= 0) {
                if (sb.length > 0) {
                    if (key in result.results) {
                        result.hasDuplicateKeys = true;
                    }
                    result.results[key] = sb.trim();
                    sb = '';
                }

                const splitted = s.split(':');
                key = splitted[0];
                sb += splitted[1];
            }
            else {
                sb += ' ' + s;
            }
        });

    if (sb.length > 0) {
        if (key in result.results) {
            result.hasDuplicateKeys = true;
        }
        result.results[key] = sb.trim();
        sb = '';
    }

    return result;
}

export function tokenize(value: string): Dictionary<string> {
    const result = getTokenize(value);
    return result.results;
}

export function isTokenizable(value: string): boolean {
    const result = getTokenize(value);
    return !result.hasDuplicateKeys;
}